import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid, Table, Button } from 'react-bootstrap';
import ModuleHeader from '../../components/ModuleHeader';
import { orderShopsOperations, orderShopsSelectors } from "./state";
import TableTemplate from '../../components/TableTemplate';
import { ORDER, ORDER_ITEMS } from '../BPOrder/routes';
import { EMPTY_COUNT } from '../../../utils/constants';
import view from '../../../includes/img/viewdetails.svg';

class OrderShops extends Component {
    constructor(props) {
        super(props);
        this.state = {
            totalOrder: EMPTY_COUNT,
            ...this.props.location.state && this.props.location.state.proposal
        };
    }

    componentWillMount() {
        this.props.fetchDefault({ proposalId: this.state.proposalId, orderDttm: this.state.deliveryDttm })
            .then(() => {
                let totalOrder = EMPTY_COUNT;
                let list = this.props.tableList
                list && list.map(record =>
                    totalOrder += record.totalProducts
                )
                this.setState({ list: list, totalOrder: totalOrder })
            });
        if (this.props.location.state && this.props.location.state.proposal) {
            if (this.props.location.state.proposal.orderDateDisplay) {
                this.setState({ orderDateDisplay: this.state.orderDateDisplay })
            } else {
                this.setState({ orderDateDisplay: this.state.orderDate + " " + this.state.orderTime })
            }
        }
    }


    orderItems = (data) => {
        this.props.history.push({
            pathname: ORDER_ITEMS,
            state: {
                proposal:
                {
                    proposalId: this.state.proposalId,
                    proposalName: this.state.proposalName,
                    orderDateDisplay: this.state.orderDateDisplay,
                    orderDttm: this.state.orderDttm,
                    deliveryDttm: this.state.deliveryDttm,
                    deadline: this.state.deadline,
                    shopMain: data.shopMainNumber,
                    shopBranch: data.shopBranchNumber,
                    shopName: data.shopName,
                    closingDateTime: this.state.closingDateTime
                }
            }
        });
    }

    titleLabels() {
        return (
            <span className="title-action2">
                <span className="title-text">
                    <span className="extra-text2"><b>商品提案グループ名</b></span>
                    <span className="extra-text2"><b>発注締日時</b></span>
                </span>
                <span className="title-text">
                    <span className="extra-text3">{this.state.proposalName}</span>
                    <span className="extra-text3">{this.state.orderDateDisplay}</span>
                </span>
            </span>
        )
    }

    displayTotal = () => {
        let startIndex = 3
        let totalId = "total-shops"
        orderShopsSelectors.setTotalTableStyle(totalId, startIndex)
        return (
            <div id={totalId}>
                <br />
                <Table >
                    <tbody>
                        <tr>
                            <td id={totalId + "-" + (startIndex++)} className="table-header">計</td>
                            <td id={totalId + "-" + (startIndex++)} className="text-right">{this.state.totalOrder}</td>
                        </tr>
                    </tbody>
                </Table>
            </div>
        )
    }

    render() {
        return (
            <Grid fluid={true}>
                <Grid>
                    <ModuleHeader
                        title={"受注状況取引先一覧"}
                        titleAction={this.titleLabels()} />
                    <TableTemplate
                        {...this.props}
                        tableList={this.state.list}
                        rowButtons={[
                            {
                                onClick: this.orderItems,
                                img: view,
                                bsStyle: "link"
                            }
                        ]}
                    />

                    {this.displayTotal()}

                    <br />

                    <Button
                        className="button-filter list-button"
                        onClick={() => this.props.history.push(ORDER)}
                    >
                        戻る
                </Button>
                </Grid>
            </Grid>
        );
    }
}

const mapStateToProps = (state) => {
    return {
        businessPartnerCode: state.auth.credentials.riyo_kigyo_id,
        isAuthenticated: state.auth.isAuthenticated,
        tableHeader: state.orderShops.tableHeader,
        tableList: state.orderShops.list,
        tableColumns: state.orderShops.tableColumns,
    }
};

const mapDispatchToProps = {
    fetchDefault: orderShopsOperations.fetchDefault
};

export default connect(mapStateToProps, mapDispatchToProps)(OrderShops);